









import * as echarts from 'echarts';
import ResizeMixin from '@/components/Charts/mixins/resize';
import { deepClone } from '@/utils/function_utils';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'applicationDistributionBar',
})
export default class extends Mixins(ResizeMixin) {
  @Prop({ default: 'bar-chart' }) public className!: string;
  @Prop({ default: '480px' }) public height!: string;
  @Prop({ default: [] }) public data!: any;

  get year() {
    return UserModule.indexSelectYear;
  }

  get language() {
    return AppModule.language;
  }

  public chart: any = null;
  public xAxis: any = [];
  public legendDataType: any[] = [];
  public valueConfigs: any[] = []

  @Watch('language')
  @Watch('year')
  @Watch('data', { deep: true })
  public watchNum(val: any) {
    if (!this.chart) {
      this.initChart();
    }
    if (typeof val !== 'object') {
      this.configData();
    }
    if (this.chart && (val === null || val === undefined || val === '')) {
      this.chart.clear();
    } else {
      const seriesData = this.getSeriesData();
      this.setEchartsOptions(this.legendDataType, seriesData);
    }
  }

  public mounted() {
    this.configData();
    this.$nextTick(() => {
      this.initChart();
      const seriesData = this.getSeriesData();
      this.setEchartsOptions(this.legendDataType, seriesData);
    })
  }

  public beforeDestroy() {
    if (!this.chart) {
      return;
    }
    // 销毁实例，实例销毁后无法再被使用
    this.chart.dispose();
    this.chart = null;
  }

  public initChart() {
    const barChartDom = this.$refs.barChart;
    this.chart = echarts.init(barChartDom as HTMLDivElement);
  }

  public configData() {
    this.xAxis = [
      this.$t('common.jan'),
      this.$t('common.feb'),
      this.$t('common.mar'),
      this.$t('common.apr'),
      this.$t('common.may'),
      this.$t('common.jun'),
      this.$t('common.jul'),
      this.$t('common.aug'),
      this.$t('common.sep'),
      this.$t('common.oct'),
      this.$t('common.nov'),
      this.$t('common.dec'),
    ]
    // const year = this.year !== '0' ? this.year : '全部';
    this.legendDataType = [
      this.$t('index.applyCount'),
      this.$t('index.successfulEnrolment')
    ]
    // xAxisIndex 值相同的组共X轴，
    // (xAxisIndex为某x轴的编号，当前定义了两个X轴，编号 0,1。轴编号相同的数据为同轴数据，依次按值定义顺序排列到x轴上)
    // 由于没有定义x轴的偏移量，所以定义的两条x轴是重合的
    this.valueConfigs = [
      {
        color: '#4DCCB6',
        keyName: 'applyNums',
        name: this.$t('index.applyCount'),
        xAxisIndex: 0
      },
      {
        color: '#F6A14D',
        keyName: 'enrolledNums',
        name: this.$t('index.successfulEnrolment'),
        xAxisIndex: 0
      },
    ]
  }

  public getSeriesData() {
    const series: any = [];
    const serieInitObj = {
      name: '',
      type: 'bar',
      // show: false,
      barWidth: '30%',
      barGap: '0%', // 不同系列的柱间距离
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      xAxisIndex: 0,
      itemStyle: {
        normal: {
          color: ''
        }
      },
    }
    this.valueConfigs.forEach((item) => {
      const initObj = deepClone(serieInitObj)
      if (item.color) {
        const serieObj = this.data[item.keyName];
        initObj.itemStyle.normal.color = item.color;
        initObj.name = item.name;
        initObj.data = serieObj;
      }
      initObj.xAxisIndex = item.xAxisIndex;
      series.push(initObj);
    });
    return series;
  }

  public setEchartsOptions(legendData: any, seriesData: any) {
    this.chart.setOption({
      tooltip: {
        trigger: 'axis',
        formatter: (params: any, ticket: any, callback: any) => {
          const a = params
            .filter((_: any) => _.seriesName)
            .map((_: any) => `<span style="display: inline-block;background-color: ${_.color};width: 10px;height:10px;border-radius: 50%;margin-right:6px"></span>${_.seriesName}：${_.value}`)
            .join('</span><br/><span>');
          return `<span>${a}</span>`;
        },
        backgroundColor: 'rgba(51,51,51,0.8)',
        borderColor: 'rgba(51,51,51,0.8)',
        textStyle: {
          color: '#fff'
        },
        axisPointer: {
          type: 'shadow',
          animation: true,
          shadowStyle: {
            color: {
              width: '100%',
              type: 'linear',
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                { offset: 0, color: 'RGBA(0,0,0,0)' },
                { offset: 0.15, color: 'RGBA(0,0,0,0)' },
                { offset: 0.15, color: 'RGBA(100,100,100,0.3)' },
                { offset: 0.85, color: 'RGBA(100,100,100,0.3)' },
                { offset: 0.85, color: 'RGBA(0,0,0,0)' },
                { offset: 1, color: 'RGBA(0,0,0,0)' }
              ],
              global: false
            },
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0
          }
        }
      },
      legend: {
        // silent: true,
        // 图例的数据数组。数组项通常为一个字符串，每一项代表一个系列的 name
        // 如果 data 没有被指定，会自动从当前系列中获取。多数系列会取自 series.name
        data: legendData,
        formatter: (name: any) => {
          // if (['全部学生数', '全部学生數', 'Total students'].includes(name)) {
          //   return `${name}: ${that.allApplyStudentCountTotal}`;
          // } else if (['年学生数', '年学生數', 'Number of students in'].some((item) => name.includes(item))) {
          //   return `${name}: ${that.thisYearStudentSum ? that.thisYearStudentSum : 0}`;
          // }
          return name;
        }
      },
      grid: {
        bottom: '30'
      },
      yAxis: {
        show: true,
        type: 'value',
      },
      xAxis: [
        {
          type: 'category',
          data: this.xAxis
        },
        {
          show: false,
          type: 'category',
          data: ['', '', '', '', '', '', '', '', '', '', '', '']
        }
      ],
      series: seriesData
    }, {replaceMerge: ['series']});
    this.chart.on('click', (params: any) => {
      const month = params.dataIndex;
      const year = this.year;
      if (year !== '0') {
        const endTime = `${year}-${month + 1}-${new Date(Number(year), (month + 1), 0).getDate()}`;
        const startTime = `${year}-${(month + 1)}-1`
        this.$router.push({ name: 'applicationList', query: { startTime: startTime.toString(), endTime: endTime.toString() } })
      } else {
        this.$message.warning(this.$t('message.businessOverviewMessage') as string);
      }
    });
  }
}
